import { TextField } from "formik-material-ui";
import { Field } from "formik";

const TextInput = ({ name, label, type, autoFocus, variant, helperText }) => {
  return (
    <Field
      autoFocus={autoFocus}
      fullWidth
      variant={variant}
      autoComplete={name}
      component={TextField}
      key={name}
      type={type}
      helperText={helperText}
      name={name}
      label={label}
    />
  );
};

export default TextInput;
